import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { defaultLoginValues, Login } from 'src/app/components/login/login';
import { AuthService } from 'src/app/services/auth.service';
import { LoginService } from 'src/app/services/login.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-video-store-login-legacy',
    templateUrl: './video-store-login-legacy.component.html',
    styleUrls: ['./video-store-login-legacy.component.scss'],
    standalone: false
})
export class VideoStoreLoginLegacyComponent implements OnInit {

  loginModel: Login = defaultLoginValues();
  signInLabel: string = 'Sign in here';
  showLoginForm: boolean = true;
  username: string = '';
  translation: any;
  showError: boolean = false;

  constructor(
    private loginService: LoginService,
    private authservice: AuthService,
    private router: Router,
    private translationService: TranslationService
  ) { }

  ngOnInit(): void {
    this.loginModel.authToken = this.authservice.getUserLoginData().token;
    this.loginModel.email = this.authservice.getUserLoginData().username;

    if (this.loginModel.authToken != null) {
      this.loginService.loginUsingAuthToken(this.loginModel).subscribe({
        next: (resp) => {
          this.authservice.setUserLoginData(resp);
          this.signInLabel = "You're already logged in";
          this.showLoginForm = false;
          this.username = resp.username;
        }
      });
    }

    this.translationService.getTranslation().subscribe({
      next: (resp) => {
        this.translation = resp;
        this.signInLabel = resp['signInText'];
      }
    });
  }

  loginWithProvinceCode() {
    this.loginService.loginWithProvinceCode(this.loginModel).subscribe({
      next: (response) => {
        if (response) {
          this.authservice.setUserLoginData(response);
          this.router.navigateByUrl('/video-store-dashboard');
        } else {
          this.showError = true;
          setTimeout(() => {
            this.showError = false;
          }, 10000);
        }
      }
    });
  }
}
